import { useSearchParams } from "react-router-dom";
import { Megaphone } from "lucide-react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { MarketingAssets } from "@/components/MarketingAssets";
import { DemoLinks } from "@/components/DemoLinks";
import { BlogSettings } from "@/components/BlogSettings";
import { ContactSettings } from "@/components/ContactSettings";
import { SeoSettings } from "@/components/SeoSettings";
import { EstimateSettings } from "@/components/EstimateSettings";

const TABS = ["assets", "blog", "website"];

export default function Marketing() {
  const [sp, setSp] = useSearchParams();
  const tab = TABS.includes(sp.get("tab")) ? sp.get("tab") : "assets";
  return (
    <div className="space-y-6 animate-fade-up max-w-5xl" data-testid="marketing-page">
      <div><h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight flex items-center gap-2"><Megaphone className="w-7 h-7 text-primary" /> Marketing</h1><p className="text-sm text-muted-foreground mt-1">Sales collateral, demo links, the blog and the public website.</p></div>
      <Tabs value={tab} onValueChange={(v) => setSp({ tab: v })}>
        <TabsList data-testid="marketing-tabs">
          <TabsTrigger value="assets" data-testid="tab-assets">Flyer & demos</TabsTrigger>
          <TabsTrigger value="blog" data-testid="tab-blog">Blog</TabsTrigger>
          <TabsTrigger value="website" data-testid="tab-site">Website</TabsTrigger>
        </TabsList>
        <TabsContent value="assets" className="mt-4 space-y-6"><DemoLinks /><MarketingAssets /></TabsContent>
        <TabsContent value="blog" className="mt-4 space-y-6"><BlogSettings /></TabsContent>
        <TabsContent value="website" className="mt-4 space-y-6"><ContactSettings /><SeoSettings /><EstimateSettings /></TabsContent>
      </Tabs>
    </div>
  );
}
